import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { config } from "../../constants/config";
import { useEffect } from "react";
import { Asterisk, CreditCard, Envelope, Lock, Person, Phone, PinMap } from "react-bootstrap-icons";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function AccountInfos({codeaccount}) {
    // states
    const {user, logoutUser} = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [suspending, setSuspending] = useState(false);
    const [activing, setActiving] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [login, setLogin] = useState("");
    const [etat, setEtat] = useState("");
    const [password, setPassword] = useState("");
    const [confirmpass, setConfirmpass] = useState("");
    const [nom, setNom] = useState("");
    const [cni, setCni] = useState("");
    const [email, setEmail] = useState("");
    const [tel, setTel] = useState("");
    const [prenom, setPrenom] = useState("");
    const [nationalite, setNationnalite] = useState("");
    const [datecrea, setDatecrea] = useState('');
    const [logoprev, setLogoprev] = useState('/assets/imgs/no-image.png');


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }


    const getCompte = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts/${codeaccount}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setLogin(body?.login !== null ? body?.login : "");
                        setEtat(body?.etat);
                        setCni(body?.numcni !== null ? body?.numcni : "");
                        setNationnalite(body?.nationalite !== null ? body?.nationalite : "");
                        setNom(body?.nom !== null ? body?.nom : "");
                        setPrenom(body?.prenom !== null ? body?.prenom : "");
                        setTel(body?.numtel !== null ? body?.numtel : "");
                        setEmail(body?.email !== null ? body?.email : "");
                        setLogoprev(body?.photo !== null ? body?.photo : "/assets/imgs/blank.png")
                        setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 19).replace("T", " à ") : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
            
        })
        .catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }


    // comportements
    useEffect(() => {
        getCompte();
    }, []);


    const handleDelete = async () => {
        confirmAlert({
            title: 'Supprimer?',
            message: 'Etes-vous sur de vouloir suppirmer ce compte?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: 'DELETE',
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: 'follow'
                        };


                        // console.log("data send", urlencoded);

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts/${codeaccount}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage("Compte supprimé avec succès.");
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete droit", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setDeleting(false);
                            }
                            
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setDeleting(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Mise à jour?',
            message: 'Etes-vous sûr de vouloir mettre à jour ce compte?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);
                        
                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("login", login);
                        if(password) urlencoded.append("mdp", password);

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts/${codeaccount}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage("Compte mis à jour avec succès.");
                                setEditedstate(false);
                                getCompte();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setFetching(false);
                            }
                            
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setFetching(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleSuspende = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Suspendre?',
            message: 'Etes-vous sûr de vouloir suspendre ce compte?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setSuspending(true);
                        
                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "2");
                        urlencoded.append("etatdef", "Suspendu");

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts/${codeaccount}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage("Compte suspendue avec succès.");
                                setEditedstate(false);
                                getCompte();
                                setSuspending(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    let body = data?.body?.data;
                
                                    if (body.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setSuspending(false);
                                        showErrorMessage(body.msg);
                                    }
                
                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setSuspending(false);
                            }
                            
                        })
                        .catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setSuspending(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleActive = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Réactiver?',
            message: 'Etes-vous sûr de vouloir réactiver ce compte?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setActiving(true);
                        
                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "1");
                        urlencoded.append("etatdef", "Actif");

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts/${codeaccount}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage("Compte réactivée avec succès.");
                                setEditedstate(false);
                                getCompte();
                                setActiving(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    let body = data?.body?.data;
                
                                    if (body.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setActiving(false);
                                        showErrorMessage(body.msg);
                                    }
                
                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setActiving(false);
                            }
                            
                        })
                        .catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setActiving(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row"> 
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    {!editedstate && <button onClick={() => setEditedstate(true)}
                                        title="Modifier le compte" 
                                        className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                        <i className="fa fa-edit mr-1"></i> <span>Modifier</span>
                                    </button>}
                                    {!editedstate && <button onClick={handleDelete}
                                        title="Supprimer le compte" 
                                        className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                        <i className="fa fa-trash mr-1"></i> <span>Supprimer</span>  {deleting && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                        />}
                                    </button>}
                                    {!editedstate && etat === 1 && <button onClick={handleSuspende}
                                        title="Suspendre le compte" 
                                        className="btn-shadow ml-3 btn btn-warning btn-sm float-right">
                                        <i className="fa fa-arrow-down mr-1"></i> <span>Suspendre</span>  {suspending && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                        />}
                                    </button>}
                                    {!editedstate && etat === 2 && <button onClick={handleActive}
                                        title="Réactiver le compte" 
                                        className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                        <i className="fa fa-arrow-up mr-1"></i> <span>Réactiver</span>  {activing && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                        />}
                                    </button>}
                                    <h6 className="m-0 ">Informations du compte</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{width: "100%"}} onSubmit={handleSubmitEdit}>
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="row">
                                                    {/* {editedstate && <div className="col-md-12 mb-2">
                                                        <label htmlFor="photo" className="form-label">Photo de l'utilisateur</label>
                                                        <input className="form-control" type="file" id="photo" onChange={handleLogoChange} />
                                                    </div>} */}
                                                    <div className="col-md-12 mb-1">
                                                        <img alt="" src={logoprev} className="rounded" style={{width: "100%"}} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-8 mb-3">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="login" className="mb-1">Login</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="login">
                                                                <Person />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={login}
                                                                onChange={(e) => setLogin(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="etat" className="mb-1">Etat du compte</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className={`input-group-text ${
                                                                    etat === 1 ? "bg-success" :
                                                                    etat ===2 ? "bg-danger" :
                                                                    ""
                                                                }`
                                                            } 
                                                                id="etat"
                                                            >
                                                                <Asterisk />
                                                            </span>
                                                            <input
                                                                readOnly
                                                                type="text" 
                                                                className={`form-control ${
                                                                        etat === 1 ? "text-white bg-success" :
                                                                        etat ===2 ? "text-white bg-danger" :
                                                                        ""
                                                                    } 
                                                                `} 
                                                                id="etat"
                                                                value={
                                                                    etat === 1 ? "Compte actif" :
                                                                    etat ===2 ? "Compte bloqué" :
                                                                    ""
                                                                }
                                                                placeholder=""
                                                                onChange={(e) => setEtat(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    {editedstate && <div className="col-md-6 mb-3">
                                                        <label htmlFor="pass" className="mb-1">Mot de passe</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="pass">
                                                                <Lock />
                                                            </span>
                                                            <input type="password" 
                                                                className="form-control" 
                                                                placeholder="Entrez le mot de passe"
                                                                value={password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>}
                                                    {editedstate && <div className="col-md-6 mb-3">
                                                        <label htmlFor="confirmpass" className="mb-1">Confirmer Mot de passe</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="confirmpass">
                                                                <Lock />
                                                            </span>
                                                            <input type="password" 
                                                                className="form-control" 
                                                                placeholder="Entrez la confirmation du mot de passe"
                                                                value={confirmpass}
                                                                onChange={(e) => setConfirmpass(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>}
                                                    <div className="col-md-12 mb-2 mt-3">
                                                        <h4>Informations de l'utilisateur</h4>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="nom" className="mb-1">Nom</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="nom">
                                                                <Person />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={nom}
                                                                onChange={(e) => setNom(e.target.value)}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="prenom" className="mb-1">Prénom</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="prenom">
                                                                <Person />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={prenom}
                                                                onChange={(e) => setPrenom(e.target.value)}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="nat" className="mb-1">Nationnalité</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="nat">
                                                                <PinMap />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder="Entrez la nationalité "
                                                                value={nationalite}
                                                                onChange={(e) => setNationnalite(e.target.value)}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="cni" className="mb-1">Numéro pièce d'identité</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="cni">
                                                                <CreditCard />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder="Entrez le numéro de la pièce d'identité "
                                                                value={cni}
                                                                onChange={(e) => setCni(e.target.value)}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="email" className="mb-1">Adresse Email</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="email">
                                                                <Envelope />
                                                            </span>
                                                            <input type="email" 
                                                                className="form-control" 
                                                                placeholder="Entrez l'adresse email"
                                                                aria-label="Email client"
                                                                value={email}
                                                                onChange={(e) => setEmail(e.target.value)}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="tel1" className="mb-1">Telephone</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="tel1">
                                                                <Phone />
                                                            </span>
                                                            <input type="tel" 
                                                                className="form-control" 
                                                                placeholder="Ex: 690000000"
                                                                aria-label="Numéro client"
                                                                value={tel}
                                                                onChange={(e) => setTel(e.target.value)}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            {editedstate && <div className="col-md-12 mt-2">
                                                <button type="submit" 
                                                    title="Mise à jour du profil" 
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                    // disabled={names && statusinput["value"] ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i> 
                                                    <span>Modifier</span> {fetching && <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                    />}
                                                </button>
                                                <button onClick={() => setEditedstate(false)} 
                                                    title="Annuler l'operation"
                                                    className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                                    <i className="fa fa-reply mr-1"></i> <span>Annuler</span>
                                                </button>
                                            </div>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>}
        </>
    )
}